//ProjectLedgerReport.js

import React, { Component } from 'react';
import { Navigate } from 'react-router-dom';
import axios from 'axios';
import Table from '@mui/material/Table';
import TableRow from '@mui/material/TableRow';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableSortLabel from '@mui/material/TableSortLabel';
import PropTypes from 'prop-types';
import TablePagination from '@mui/material/TablePagination';
import Button from '@mui/material/Button';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import dayjs from 'dayjs';
import TextField from '@mui/material/TextField';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import * as XLSX from 'xlsx';
import SearchIcon from '@mui/icons-material/Search';
import { saveAs } from 'file-saver';
import Autocomplete from '@mui/material/Autocomplete';
import Serverurl from './Apiurl';
import {
  Container,
  Paper,
  Box,
  Typography,
  Alert,
  CircularProgress
} from '@mui/material';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import PrintIcon from '@mui/icons-material/Print';

function desc(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) return -1;
    if (b[orderBy] > a[orderBy]) return 1;
    return 0;
}

function stableSort(array, cmp) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = cmp(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map(el => el[0]);
}

function getSorting(order, orderBy) {
    return order === 'desc' ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy);
}

const headCells = [
    { id: 'Date', label: 'Date' },
    { id: 'Description', label: 'Description' },
    { id: 'In', label: 'In' },
    { id: 'Expense', label: 'Expense' },
    { id: 'Paid', label: 'Paid' }
];
function EnhancedTableHead(props) {
    const { order, orderBy, onRequestSort, rowCount, dynamicColumns } = props;
    const createSortHandler = property => event => {
        onRequestSort(event, property);
    };

    return (
        <TableHead>
            <TableRow>
                {headCells.map(headCell => (
                    <TableCell
                        key={headCell.id}
                        align={headCell.numeric ? 'right' : 'left'}
                        padding={headCell.disablePadding ? 'none' : 'default'}
                        sortDirection={orderBy === headCell.id ? order : false}
                    >
                        <TableSortLabel
                            active={orderBy === headCell.id}
                            direction={orderBy === headCell.id ? order : 'asc'}
                            onClick={createSortHandler(headCell.id)}
                        >
                            {headCell.label}
                        </TableSortLabel>
                    </TableCell>
                ))}
               
            </TableRow>
        </TableHead>
    );
}

EnhancedTableHead.propTypes = {
    onRequestSort: PropTypes.func.isRequired,
    order: PropTypes.oneOf(['asc', 'desc']).isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired,
    dynamicColumns: PropTypes.array.isRequired,
};

export default class ProjectLedgerReport extends Component {
    constructor(props) {
        super(props);
        const currentDate = new Date();
        this.state = {
            redirect: false,
            pagename: '',          
            projectId: '',
            projectName: '',from_date: dayjs().startOf('month'),
to_date: dayjs(),totalin:0,
            filteredProjects: [],
            loadingProjects: false,
            projects: [],
            projectarray: [],
            projectarrauto: [],
            selectedProject: null,
            reportData: [],
            grandTotalAmount: 0,
            loading: false,
            error: '', finalizedAmount: 0,
    paymentInDue: 0,
    totalExpense: 0,
    totalPaid: 0,
    paymentOutDue: 0,
            totalHeads: 0,
            totalAmount: 0,
            page: 0,
            rowsPerPage: 10,
            order: 'desc',
            orderBy: 'Date',
            dynamicColumns: [],
            openExportDialog: false,
        };
    }
apicall = () => {
    this.setState({
        loading: true,
        error: ""
    });

    let url =
        Serverurl +
        "ajaxprojects.php?action=getprojectledgerreport" +
        "&project_id=" + this.state.projectId +
        "&index=" + this.state.page +
        "&maxrecrd=" + this.state.rowsPerPage +
        "&orderby=" + this.state.orderBy;

    if (this.state.from_date) {
        url +=
            "&from_date=" +
            dayjs(this.state.from_date).format("YYYY-MM-DD");
    }

    if (this.state.to_date) {
        url +=
            "&to_date=" +
            dayjs(this.state.to_date).format("YYYY-MM-DD");
    }

    axios
        .get(url)
        .then((resp) => {

            let ledgerRows = Array.isArray(resp.data)
                ? resp.data
                : [];

            const finalizedAmount =
                Number(this.state.finalizedAmount || 0);

            const totalCustomerPayment = ledgerRows.reduce(
                (sum, row) =>
                    sum + Number(row.In || 0),
                0
            );

            const totalExpense = ledgerRows.reduce(
                (sum, row) =>
                    sum + Number(row.Expense || 0),
                0
            );

            const totalPaid = ledgerRows.reduce(
                (sum, row) =>
                    sum + Number(row.Paid || 0),
                0
            );

            const paymentInDue =
                finalizedAmount - totalCustomerPayment;

let paymentOutDue=0;
if(totalExpense>totalPaid)
{
	    paymentOutDue =
                totalExpense - totalPaid;
}
	
         

            this.setState({
                reportData: ledgerRows,
totalin:totalCustomerPayment,
                finalizedAmount,
                paymentInDue,
                totalExpense,
                totalPaid,
                paymentOutDue,
	totalRecords: ledgerRows.length,
                loading: false
            });
        })
        .catch(() => {
           
        });
};
selectProject = (event, value) => {

    this.setState({
        projectId: value ? value.pj_id : '',
        projectName: value ? value.pj_projectname : '',
        finalizedAmount: value
            ? Number(value.pj_finalizedamount || 0)
            : 0
    }, () => {

        if (this.state.projectId) {
            this.apicall();
        }

    });
};

searchProject = (event, value) => {
    this.setState({
        projectName: value,
        projectId: '',
        loadingProjects: true
    });

    if (!value || value.trim() === '') {
        this.setState({
            filteredProjects: [],
            loadingProjects: false
        });
        return;
    }

    axios
        .get(Serverurl + "ajaxprojects.php?action=getallprojectautoextender&pj_projectname=" + value)
        .then((response) => {
            this.setState({
                filteredProjects: response.data || [],
                loadingProjects: false
            });
        })
        .catch(() => {
            this.setState({
                loadingProjects: false
            });
        });
};
     
   
      componentWillMount() {
        document.title = "VR Builders - Project Ledger Report";
        
   	if(localStorage.getItem("VRuserid")==null)
		  {

		   this.setState({
            redirect: true,
			pagename:'/Userlogin'
          })
		  }
let strname="Project Ledger";   
			 this.props.parentsCallback(
           strname
        );
    }

    handleInputChange = (event) => {
        this.setState({ [event.target.name]: event.target.value });
    };
handleSearch = () => {

    if (!this.state.projectId) {
        this.setState({
            error: "Please select project",
            reportData: []
        });
        return;
    }

    this.setState({
        error: "",
        page: 0
    }, () => {
        this.apicall();
    });
};

    handleRequestSort = (event, property) => {
        const isAsc = this.state.orderBy === property && this.state.order === 'asc';
        this.setState({
            orderBy: property,
            order: isAsc ? 'desc' : 'asc',
            page: 0
        }, () => {
            this.apicall(0, this.state.rowsPerPage);
        });
    };

    handleChangePage = (event, newPage) => {
        this.setState({ page: newPage }, () => {
            this.apicall(newPage, this.state.rowsPerPage);
        });
    };

    handleChangeRowsPerPage = event => {
        this.setState({
            page: 0,
            rowsPerPage: parseInt(event.target.value)
        }, () => {
            this.apicall(0, parseInt(event.target.value));
        });
    };
    handleOpenExportDialog = () => {
        this.setState({ openExportDialog: true });
    };

    handleCloseExportDialog = () => {
        this.setState({ openExportDialog: false });
    };
handleDownloadPDF = () => {
    const doc = new jsPDF("l", "mm", "a4");

    doc.setFontSize(14);
    doc.text("Project Ledger Report", 14, 15);

const rows = this.state.reportData.map((item) => [
    item.Date || "",
    item.Description || "",
    Number(item.In || 0).toLocaleString("en-IN"),
    Number(item.Expense || 0).toLocaleString("en-IN"),
    Number(item.Paid || 0).toLocaleString("en-IN")
]);

    rows.push([
        "Grand Total",
        "",
        "",
        Number(this.state.grandTotalAmount).toLocaleString("en-IN")
    ]);

    doc.autoTable({
       head: [[
    "Date",
    "Description",
    "In",
    "Expense",
    "Paid"
]],
        body: rows,
        startY: 25
    });

    doc.save("ProjectPaymentDueReport.pdf");
};
exportExcel = () => {

let excelData = this.state.reportData.map((item) => ({
    Date: item.Date,
    Description: item.Description,
    In: item.In,
    Expense: item.Expense,
    Paid: item.Paid
}));

    excelData.push({
        Project: "Grand Total",
        FinalizedAmount: "",
        PaymentIn: "",
        Due: this.state.grandTotalAmount
    });

    const ws = XLSX.utils.json_to_sheet(excelData);

    const wb = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(
        wb,
        ws,
        "Project Ledger Report"
    );

    const buffer = XLSX.write(wb, {
        bookType: "xlsx",
        type: "array"
    });

    saveAs(
        new Blob([buffer], {
            type: "application/octet-stream"
        }),
        "ProjectPaymentDueReport.xlsx"
    );

    this.setState({
        openExportDialog: false
    });
};
  printReport = () => {
        window.print();
        this.setState({ openExportDialog: false });
    };

    render() {
        if (this.state.redirect) {
            return <Navigate to={this.state.pagename} />;
        }

        const { reportData, order, orderBy, page, rowsPerPage, totalRecords, openExportDialog, loading, error, dynamicColumns } = this.state;
        const visibleRows = stableSort(reportData, getSorting(order, orderBy));

        return (
            <React.Fragment>
              
                   
                       

                         <div className="searchmaster">
                            <ul>
                            
                                <li>
                                    <p><span className="validation">*</span> Project </p>
                                  <p>  <Autocomplete
                                        fullWidth className="inputcntlparent"
                                        options={this.state.filteredProjects}
                                        value={
                                            this.state.filteredProjects.find(
                                                (x) => x.pj_id === this.state.projectId
                                            ) || null
                                        }
                                        getOptionLabel={(option) =>
                                            option.pj_projectname || ''
                                        }
                                        onInputChange={this.searchProject}
                                        onChange={this.selectProject}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                variant="outlined"
                                                fullWidth
                                              size="small"
                                                placeholder="Search Project"
                                            />
                                        )}
                                    /></p>
                                </li>
                               <li><p>From Date</p>
    <p><LocalizationProvider dateAdapter={AdapterDayjs}>
        <DatePicker
            label="From Date" className="inputcntlparent"
			disableFuture
            value={this.state.from_date}
            onChange={(newValue) =>
                this.setState({ from_date: newValue })
            }
			 format="DD/MM/YYYY"
			
        />
    </LocalizationProvider></p>
</li>

<li><p>To Date</p>
   <p> <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DatePicker className="inputcntlparent"
            label="To Date"
			disableFuture
            value={this.state.to_date}
            onChange={(newValue) =>
                this.setState({ to_date: newValue })
            }
			 format="DD/MM/YYYY"
        />
    </LocalizationProvider></p>
</li>
                                <li>
                                    <p>&nbsp;</p>
                                    <Button variant="contained" className="exportbtn" onClick={this.handleSearch} endIcon={<SearchIcon />}>
                                        Search
                                    </Button> <Button
                                        variant="contained"
                             
                                        className="exportbtn"
                                        onClick={this.handleOpenExportDialog}
                                    >
                                        EXPORT
                                    </Button>
                                </li>
                                
                            </ul>
                        </div>
 <Paper>
                        <TableContainer>
                            <Table id="laborreport">
                                <EnhancedTableHead
                                    order={order}
                                    orderBy={orderBy}
                                    onRequestSort={this.handleRequestSort}
                                    rowCount={reportData.length}
                                    dynamicColumns={dynamicColumns}
                                />
                                <TableBody>
    {reportData.length === 0 ? (
         <TableRow>
        <TableCell colSpan={5} align="center">
            {this.state.projectId
                ? "No Records"
                : "Please select project"}
        </TableCell>
    </TableRow>
    ) : (
        reportData.map((item, index) => (
		
		<>
            <TableRow key={index}>
               <TableCell>
     {
        item.Date
            ? dayjs(item.Date).format("DD/MM/YYYY")
            : ""
    }
</TableCell>

<TableCell>
    {item.Description}
</TableCell>

<TableCell>
    {parseFloat(item.In || 0).toLocaleString("en-IN")}
</TableCell>

<TableCell>
    {parseFloat(item.Expense || 0).toLocaleString("en-IN")}
</TableCell>

<TableCell>
    {parseFloat(item.Paid || 0).toLocaleString("en-IN")}
</TableCell>

            </TableRow>
			
			
		</>
        ))
		
    )}
<TableRow >	
		 <TableCell colSpan={2}><b>Total</b></TableCell>
		  <TableCell ><b>Rs. {parseFloat(
                                this.state.totalin
                            ).toLocaleString("en-IN")}</b></TableCell>
		  <TableCell ><b>Rs. {parseFloat(
                                this.state.totalExpense
                            ).toLocaleString("en-IN")}</b></TableCell>
							
							 <TableCell ><b>Rs. {parseFloat(
                                this.state.totalPaid
                            ).toLocaleString("en-IN")}</b></TableCell>
		  </TableRow>
</TableBody>
                            </Table>
                        </TableContainer>
{
    this.state.projectId &&
    (
        <Paper sx={{paddingLeft:"8px"}}>
            <h4>
                Project Summary
            </h4>

            <table width="100%" cellpadding="5">
                <tbody>

                    <tr>
                        <td> Finalized Amount </td>
                        <td> 
                           <b> Rs. {parseFloat(
                                this.state.finalizedAmount
                            ).toLocaleString("en-IN")} </b>
                        </td>
                    </tr>

                    
                    <tr>
                        <td> Payment In Due </td>
                        <td> 
                           <b> Rs. {parseFloat(
                                this.state.paymentInDue
                            ).toLocaleString("en-IN")} </b>
                        </td>
                    </tr>

                    <tr>
                        <td> Payment Out Due </td>
                        <td> 
                            <b>Rs. {parseFloat(
                                this.state.paymentOutDue
                            ).toLocaleString("en-IN")}</b> 
                        </td>
                    </tr>

                </tbody>
            </table>
        </Paper>
    )
}

                        <Dialog open={openExportDialog} onClose={this.handleCloseExportDialog}>
                            <DialogTitle>Export Labor Report</DialogTitle>
                            <DialogContent>
                                <p>Choose export format:</p>
                                <p style={{ textAlign: 'center', display: 'flex', justifyContent: 'center', gap: '20px' }}>
                                    <Button
                                        variant="contained"
                                        startIcon={<FileDownloadIcon />}
                                        onClick={this.exportExcel}
                                        sx={{
                                            backgroundColor: '#2e7d32',
                                            '&:hover': {
                                                backgroundColor: '#1b5e20'
                                            }
                                        }}
                                    >
                                        Excel
                                    </Button>
                                    <Button
                                        variant="contained"
                                        startIcon={<PictureAsPdfIcon />}
                                        onClick={this.handleDownloadPDF}
                                        sx={{
                                            backgroundColor: '#d32f2f',
                                            '&:hover': {
                                                backgroundColor: '#b71c1c'
                                            }
                                        }}
                                    >
                                        PDF
                                    </Button>
                                </p>
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={this.handleCloseExportDialog}>Cancel</Button>
                            </DialogActions>
                        </Dialog>
                    </Paper>
               
            </React.Fragment>
        );
    }
}